import React, { useState, useEffect } from "react";
import { API } from "@/App";

export const useSignatureImage = (sig, token) => {
  const [url, setUrl] = useState(null);
  useEffect(() => {
    if (!sig?.has_image) { setUrl(null); return; }
    let u;
    fetch(`${API}/staff/signatures/${sig.signature_id}/image`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.ok ? r.blob() : null).then(b => { if (b) { u = URL.createObjectURL(b); setUrl(u); } }).catch(() => {});
    return () => u && URL.revokeObjectURL(u);
  }, [sig?.signature_id, sig?.has_image, sig?.updated_at, token]);
  return url;
};

export const SignatureBlock = ({ sig, token, compact }) => {
  const img = useSignatureImage(sig, token);
  if (!sig) return null;
  const team = sig.signature_type === "team";
  return (
    <div data-testid={`signature-block-${sig.signature_id}`}>
      {!team && img && <img src={img} alt="Signature" className={`${compact ? "h-8" : "h-12"} w-auto object-contain mb-1`} />}
      <div className="w-24 h-0.5 bg-[#FF7A00] mb-1.5" />
      <p className={`${compact ? "text-xs" : "text-sm"} font-bold text-stone-900`}>{sig.full_name}</p>
      {!team && sig.professional_title && <p className="text-[11px] text-stone-600">{sig.professional_title}</p>}
    </div>
  );
};
